// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductionCycleInfo_container__1JVDt","label":"ProductionCycleInfo_label__kKNIS"};